import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  role?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <section className={`w-full ${background === 'white' ? 'bg-white' : 'bg-ivory'} py-16 sm:py-20`} data-id="element-217" data-mp="3b0ayqdawmxnp">
      <div className="mx-auto max-w-6xl px-5" data-id="element-218" data-mp="36wmofmuw1nyr">
        {title && <>
            <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-219" data-mp="31yl6545adsoc">
              {title}
            </h2>
            <div className="rule-gold mx-auto mt-6 w-32" aria-hidden="true" data-id="element-220" data-mp="2x2mkvpf98qs5" />
          </>}

        <ul className={`grid gap-6 sm:grid-cols-3 ${title ? 'mt-12' : ''}`} data-id="element-221" data-mp="v9gbnrq5car9">
          {testimonials.map(testimonial => <li key={testimonial.quote} className="flex flex-col border border-gold-soft/70 bg-ivory p-7" data-id="element-222" data-mp="q9tvb9f0uee8">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-223" data-mp="h4n6uketiff5">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-224" data-mp="780n5yy89uep" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-225" data-mp="zw68amt71lf2">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-gold-soft/70 pt-5" data-id="element-226" data-mp="q6wcowz55km7">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold-tint font-serif text-sm text-gold-dark" data-id="element-227" data-mp="v5pp0m2oz5ks">
                  {testimonial.author.charAt(0)}
                </span>
                <span data-id="element-228" data-mp="1nmk0cdbs3k9n">
                  <span className="block text-sm font-semibold text-ink" data-id="element-229" data-mp="1nn23ltwuyyr2">
                    {testimonial.author}
                  </span>
                  {testimonial.role && <span className="block text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-230" data-mp="1sie84va0m5n7">
                      {testimonial.role}
                    </span>}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}